export default {
    purchase: 'Purchase Athlisis',
    error: 'Εάν πιστεύετε ότι έχει γίνει λάθος, επικοινωνήστε μαζί μας στο info@athlisis.com',
    contact: 'Επικοινωνήστε μαζί μας στο info@athlisis.com',
    title: 'Ευχαριστούμε για την εγγραφή σας στο athlisis!',
    subtitle: 'Ολοκληρώστε την παραγγελία σας για να χρησιμοποιήσετε την εφαρμογή!',
    heading: 'Activate athlisis',
    brandPanel: {
        title: 'You\'re one step away!',
        subtitle: 'Complete activation and unlock every tool athlisis has to offer.',
        benefits: {
            unlimited: {title: 'Unlimited clients & plans', desc: 'No hidden usage caps.'},
            mobile: {title: 'Mobile app for your clients', desc: 'Meal tracking and push notifications on the go.'},
            support: {title: 'Support & updates', desc: 'New features and help whenever you need it.'},
        }
    },
    sections: {
        payment: 'Payment method',
        document: 'Document type',
        billingDetails: 'Billing details',
    },
    orderSummary: 'Order summary',
    plan: 'Athlisis Premium',
    subtotal: 'Subtotal',
    discount: 'Discount',
    totalDue: 'Total due',
    save: 'Save',
    securePayment: 'Secure payment via Stripe',
    haveCoupon: 'Have a coupon code?',
    applyCoupon: 'Apply',
    removeCoupon: 'Remove',
    perInstalment: 'per instalment',
    instalmentsHint: '{count} payments of {amount}€',
    paymentSchedule: 'Payment schedule',
    now: 'Now',
    dueBy: 'by {date}',
    completeOrderBtn: 'Ολοκλήρωση παραγγελίας',
    startingPrice: 'Αρχική τιμή',
    salePrice: 'Εκπτωτική τιμή',
    pay: 'Πληρωμή',
    total: 'Ολόκληρο το ποσό',
    instalmentsLabel: '{count} instalments',
    document: 'Αποδεικτικό',
    invoice: 'Τιμολόγιο',
    receipt: 'Απόδειξη',
    finalizePayment: 'Ολοκλήρωση πληρωμής',
    paymentFailed: 'The payment didn\'t go through. Try again, or write to us at info@athlisis.com.',
    coupon: {
        name: 'Κωδικός κουπονιού',
        added: 'Coupon code {code} applied successfully.',
        invalid: 'This coupon code is invalid or has expired.',
        failed: 'We couldn\'t verify this coupon. Please try again.',
    },
    placeholder: {
        occupation: 'Εισάγετε το επάγγελμά σας (τομέας δραστηριότητας της εταιρείας)',
        company: 'Εισάγετε την επωνυμία της εταιρείας σας',
        doy: 'Εισάγετε τον Α.Φ.Μ. σας',
        vat: 'Εισάγετε τη Δ.Ο.Υ. σας',
        phone: 'Εισάγετε το κινητό σας',
        address: 'Εισάγετε την διεύθυνση της εταιρείας σας'
    },
    instalmentTooltip: 'Κάθε δόση πρέπει να εξοφληθεί εντός της προθεσμίας της.',
    invoiceIntro: 'Παρακαλώ εισάγετε τα στοιχεία τιμολόγησής σας για την έκδοση του τιμολογίου σας.<br>\n' +
        'Εάν είστε επαγγελματίας στην Κύπρο, μην ξεχάσετε να βάλετε το πρόθεμα (CY).',
    vat: 'Φ.Π.Α {amount}%',
    logout: 'Αποσύνδεση;',
    connectedAs: 'Συνδεδεμένος ως <strong>{firstName} {lastName}</strong> (email: <strong>{email}</strong>)',
    expired: 'Η συνδρομή σας έχει λήξει.',
    renew: 'Ανανεώστε την τώρα κάνοντας κλικ εδώ',
    willExpireSingle: 'Η συνδρομή σας λήγει σε 1 ημέρα',
    willExpirePlural: 'Η συνδρομή σας λήγει σε {days} ημέρες',

    transaction: {
        title: 'Πληρωμή συναλλαγής',
        subtitle: 'Πληρώστε με ασφάλεια μέσω του ασφαλούς συστήματος πληρωμών.',
        payUntil: 'Πληρωμή έως',
        cost: 'Κόστος συναλλαγής',
        payTx: 'Πληρωμή συναλλαγής',
        payTxText: 'Πληρώστε άμεσα με την πιστωτική / χρεωστική σας κάρτα μέσω του ασφαλούς συστήματος πληρωμών μας.',
        invoiceText: 'Για να συνεχίσετε την πληρωμή σας με τιμολόγιο, παρακαλώ συμπληρώστε τα υποχρεωτικά στοιχεία\n' +
            '                  τιμολόγησής σας (ΑΦΜ, διεύθυνση, κινητό τηλέφωνο, επωνυμία).',
        invoiceTextBtn: 'Πατήστε εδώ για να τα συμπληρώσετε.',
    }
}